import { SkillEngine } from "../components/SkillEngine";
import { useEmployees } from "../stores";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function SkillsPage() {
  useDocumentTitle('Skills – qtplan');
  const employees = useEmployees();
  return <SkillEngine employees={employees} />;
}
